import * as React from "react";
import { InputBase, CssBaseline } from "@mui/material";
import StyledSearchArea from "./styles";

const MainSearch = ({
  placeholder = "Buscar...",
  onClick,
  onChange,
  onFocus,
  id,
  autoComplete = "off",
  disabled,
}) => {
  return (
    <StyledSearchArea>
      <InputBase
        onFocus={onFocus}
        onClick={onClick}
        onChange={onChange}
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
        id={id}
        autoComplete={autoComplete}
        disabled={disabled}
      />
      <CssBaseline />
    </StyledSearchArea>
  );
};

export default MainSearch;
